(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('store-locator')) return;

    const LEAFLET = {
      css: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.css',
      cssIntegrity: 'sha384-sHL9NAb7lN7rfvG5lfHpm643Xkcjzp4jFvuavGOndn6pjVqS6ny56CAt3nsEVT4H',
      js: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.js',
      jsIntegrity: 'sha384-cxOPjt7s7Iz04uaHJceBmS+qpjv2JkIHNVcuOrM+YHwZOmJGBXI00mdUXEq65HTH',
    };
    let leafletPromise;
    // Attente après un déplacement ou un zoom avant de filtrer la liste.
    const FILTER_DELAY = 300;

    // Charge Leaflet une seule fois pour toute la page.
    function loadLeaflet() {
      if (window.L) return Promise.resolve(window.L);
      if (leafletPromise) return leafletPromise;
      leafletPromise = new Promise((resolve, reject) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = LEAFLET.css;
        link.integrity = LEAFLET.cssIntegrity;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);

        const script = document.createElement('script');
        script.src = LEAFLET.js;
        script.integrity = LEAFLET.jsIntegrity;
        script.crossOrigin = 'anonymous';
        script.onload = () => resolve(window.L);
        script.onerror = reject;
        document.head.appendChild(script);
      });
      return leafletPromise;
    }

    class StoreLocator extends HTMLElement {
      connectedCallback() {
        this.mapElement = this.querySelector('[data-store-locator-map]');
        this.items = [...this.querySelectorAll('[data-store-locator-item]')];
        this.sortItems();
        this.initSearch();

        // La carte n'est chargée qu'à l'approche de la section.
        if (!('IntersectionObserver' in window)) {
          this.startMap();
          return;
        }
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.startMap();
        }, { rootMargin: '300px' });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.searchController) this.searchController.abort();
        clearTimeout(this.filterTimer);
        if (this.map) this.map.remove();
      }

      // Démarre la carte une seule fois (au défilement ou dès la première recherche).
      startMap() {
        if (!this.mapPromise) {
          if (this.observer) this.observer.disconnect();
          this.mapPromise = this.initMap();
        }
        return this.mapPromise;
      }

      /* ---------- Recherche d'un lieu (Photon, données OpenStreetMap) ---------- */

      initSearch() {
        this.searchInput = this.querySelector('[data-store-locator-search-input]');
        this.suggestionsList = this.querySelector('[data-store-locator-suggestions]');
        if (!this.searchInput || !this.suggestionsList) return;
        this.suggestions = [];
        this.activeIndex = -1;

        this.searchInput.addEventListener('input', () => {
          clearTimeout(this.searchTimer);
          const query = this.searchInput.value.trim();
          if (query.length < 3) {
            this.closeSuggestions();
            return;
          }
          this.searchTimer = setTimeout(() => this.fetchSuggestions(query), 300);
        });

        this.searchInput.addEventListener('keydown', (event) => {
          const open = !this.suggestionsList.hidden && this.suggestions.length > 0;
          if (event.key === 'ArrowDown' && open) {
            event.preventDefault();
            this.highlight((this.activeIndex + 1) % this.suggestions.length);
          } else if (event.key === 'ArrowUp' && open) {
            event.preventDefault();
            this.highlight((this.activeIndex - 1 + this.suggestions.length) % this.suggestions.length);
          } else if (event.key === 'Enter') {
            event.preventDefault();
            if (open) this.choose(Math.max(this.activeIndex, 0));
          } else if (event.key === 'Escape') {
            this.closeSuggestions();
          }
        });

        this.searchInput.addEventListener('blur', () => this.closeSuggestions());
        // mousedown plutôt que click : la suggestion est choisie avant que le champ perde le focus.
        this.suggestionsList.addEventListener('mousedown', (event) => {
          const option = event.target.closest('[data-index]');
          event.preventDefault();
          if (option) this.choose(Number(option.dataset.index));
        });
      }

      async fetchSuggestions(query) {
        if (this.searchController) this.searchController.abort();
        this.searchController = new AbortController();
        const url = new URL('https://photon.komoot.io/api/');
        url.searchParams.set('q', query);
        url.searchParams.set('limit', '6');
        const lang = (document.documentElement.lang || '').slice(0, 2);
        url.searchParams.set('lang', ['fr', 'en', 'de'].includes(lang) ? lang : 'default');

        try {
          const response = await fetch(url, { signal: this.searchController.signal });
          const data = await response.json();
          const seen = new Set();
          this.suggestions = data.features.map((feature) => this.toSuggestion(feature)).filter((suggestion) => {
            const key = suggestion.title + '|' + suggestion.context;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
          });
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.suggestions = [];
        }
        this.renderSuggestions();
      }

      toSuggestion(feature) {
        const p = feature.properties;
        const street = [p.housenumber, p.street].filter(Boolean).join(' ');
        const title = p.name || street;
        const city = p.city && p.city !== title ? [p.postcode, p.city].filter(Boolean).join(' ') : '';
        const context = [
          p.name && street ? street : '',
          city,
          p.country && p.country !== title ? p.country : '',
        ].filter(Boolean).join(', ');
        const [lng, lat] = feature.geometry.coordinates;
        // Photon fournit l'emprise des villes, régions et pays : [ouest, nord, est, sud].
        const bounds = p.extent ? [[p.extent[1], p.extent[0]], [p.extent[3], p.extent[2]]] : null;
        const zooms = { house: 17, street: 16, locality: 14, district: 13, city: 12, county: 9, state: 7, country: 5 };
        return { title, context, lat, lng, bounds, zoom: zooms[p.type] || 12 };
      }

      renderSuggestions() {
        const list = this.suggestionsList;
        list.replaceChildren();
        this.activeIndex = -1;
        this.searchInput.removeAttribute('aria-activedescendant');

        if (!this.suggestions.length) {
          const empty = document.createElement('li');
          empty.className = 'store-locator__suggestion store-locator__suggestion--empty';
          empty.setAttribute('role', 'option');
          empty.setAttribute('aria-disabled', 'true');
          empty.textContent = this.querySelector('.store-locator__search').dataset.noResult;
          list.appendChild(empty);
        }

        this.suggestions.forEach((suggestion, index) => {
          const option = document.createElement('li');
          option.id = `${list.id}-${index}`;
          option.className = 'store-locator__suggestion';
          option.setAttribute('role', 'option');
          option.setAttribute('aria-selected', 'false');
          option.dataset.index = index;
          const title = document.createElement('span');
          title.textContent = suggestion.title;
          option.appendChild(title);
          if (suggestion.context) {
            const context = document.createElement('span');
            context.className = 'store-locator__suggestion-context';
            context.textContent = suggestion.context;
            option.appendChild(context);
          }
          list.appendChild(option);
        });

        list.hidden = false;
        this.searchInput.setAttribute('aria-expanded', 'true');
      }

      highlight(index) {
        this.activeIndex = index;
        [...this.suggestionsList.children].forEach((option, i) => option.setAttribute('aria-selected', String(i === index)));
        const active = this.suggestionsList.children[index];
        if (active) this.searchInput.setAttribute('aria-activedescendant', active.id);
      }

      closeSuggestions() {
        clearTimeout(this.searchTimer);
        this.suggestionsList.hidden = true;
        this.searchInput.setAttribute('aria-expanded', 'false');
        this.searchInput.removeAttribute('aria-activedescendant');
      }

      async choose(index) {
        const suggestion = this.suggestions[index];
        if (!suggestion) return;
        this.searchInput.value = [suggestion.title, suggestion.context].filter(Boolean).join(', ');
        this.closeSuggestions();

        await this.startMap();
        if (!this.map) return;
        this.map.closePopup();
        if (window.matchMedia('(max-width: 767px)').matches) {
          this.mapElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        if (suggestion.bounds) {
          this.map.flyToBounds(suggestion.bounds, { padding: [30, 30], maxZoom: 16, duration: 0.8 });
        } else {
          this.map.flyTo([suggestion.lat, suggestion.lng], suggestion.zoom, { duration: 0.8 });
        }
      }

      // Tri par pays (France en premier) puis par nom. Le pays est la fin de l'adresse.
      sortItems() {
        const list = this.querySelector('[data-store-locator-list]');
        if (!list) return;
        const key = (item) => {
          const address = item.querySelector('[data-store-locator-address]').textContent;
          const country = address.split(',').pop().trim();
          const name = item.querySelector('.store-locator__name').textContent.trim();
          return { first: country === 'France' ? 0 : 1, country, name };
        };
        const collator = new Intl.Collator('fr', { sensitivity: 'base' });
        this.items
          .map((item) => ({ item, key: key(item) }))
          .sort((a, b) => a.key.first - b.key.first
            || collator.compare(a.key.country, b.key.country)
            || collator.compare(a.key.name, b.key.name))
          .forEach(({ item }) => list.appendChild(item));
      }

      async initMap() {
        let L;
        try {
          L = await loadLeaflet();
        } catch (error) {
          this.mapElement.hidden = true;
          return;
        }
        if (!this.isConnected) return;

        this.map = L.map(this.mapElement, { scrollWheelZoom: false, zoomControl: false });
        // Boutons de zoom recréés pour traduire leurs intitulés (en anglais par défaut dans Leaflet).
        L.control.zoom({
          zoomInTitle: this.dataset.zoomInLabel || 'Zoom avant',
          zoomOutTitle: this.dataset.zoomOutLabel || 'Zoom arrière',
        }).addTo(this.map);
        // Crédit Leaflet conservé, sans le drapeau ajouté par défaut depuis la version 1.9.
        this.map.attributionControl.setPrefix('<a href="https://leafletjs.com" target="_blank" rel="noopener">Leaflet</a>');
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>',
        }).addTo(this.map);

        // La molette ne zoome qu'après un clic sur la carte, pour ne pas bloquer le défilement de la page.
        this.map.on('click', () => this.map.scrollWheelZoom.enable());
        this.map.on('mouseout', () => this.map.scrollWheelZoom.disable());

        const color = this.dataset.markerColor || '#000000';
        this.allBounds = [];
        this.markers = new Map();

        this.items.forEach((item) => {
          const lat = parseFloat(item.dataset.lat);
          const lng = parseFloat(item.dataset.lng);
          if (Number.isNaN(lat) || Number.isNaN(lng)) return;

          const popup = item.querySelector('[data-store-locator-details]').cloneNode(true);
          popup.querySelectorAll('.visually-hidden').forEach((el) => el.remove());
          // Dans la fenêtre de la carte, le nom redevient du texte simple.
          popup.querySelectorAll('.store-locator__name-button').forEach((button) => button.replaceWith(button.textContent));

          const marker = L.circleMarker([lat, lng], {
            radius: 8,
            color: '#ffffff',
            weight: 2,
            fillColor: color,
            fillOpacity: 1,
          }).addTo(this.map).bindPopup(popup, { maxWidth: 260 });

          marker.on('popupopen', () => this.setActive(item));
          marker.on('popupclose', () => item.classList.remove('is-active'));
          this.markers.set(item, marker);
          this.allBounds.push([lat, lng]);

          // Le nom et « Afficher sur la carte » zooment tous deux sur le magasin.
          item.querySelectorAll('[data-store-locator-show]').forEach((button) => {
            button.addEventListener('click', () => this.showOnMap(item));
          });
        });

        // La liste ne garde que les magasins visibles sur la carte, une fois le déplacement ou le zoom terminé :
        // un nouveau mouvement pendant l'attente annule le filtrage prévu.
        this.noMatch = this.querySelector('[data-store-locator-no-match]');
        this.map.on('movestart', () => {
          clearTimeout(this.filterTimer);
          this.showingAll = false;
        });
        this.map.on('moveend', () => {
          clearTimeout(this.filterTimer);
          this.filterTimer = setTimeout(() => this.filterList(), FILTER_DELAY);
        });
        const showAll = this.querySelector('[data-store-locator-show-all]');
        if (showAll) showAll.addEventListener('click', () => this.fitAll());

        this.fitAll();
      }

      fitAll() {
        this.map.closePopup();
        if (this.allBounds.length) {
          this.map.fitBounds(this.allBounds, { padding: [30, 30], maxZoom: 13 });
        } else {
          this.map.setView([46.6, 2.4], 5);
        }
        // Vue d'ensemble : toute la liste reste affichée, même si des magasins débordent du cadre
        // (carte étroite) ; le filtre reprend au déplacement suivant.
        this.showingAll = true;
        this.filterList();
      }

      filterList() {
        if (!this.map) return;
        const view = this.map.getBounds();
        let visibleCount = 0;
        this.items.forEach((item) => {
          const marker = this.markers.get(item);
          const visible = this.showingAll || (Boolean(marker) && view.contains(marker.getLatLng()));
          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        if (this.noMatch) this.noMatch.hidden = visibleCount > 0 || this.items.length === 0;
      }

      showOnMap(item) {
        const marker = this.markers && this.markers.get(item);
        if (!marker) return;
        if (window.matchMedia('(max-width: 767px)').matches) {
          this.mapElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        this.map.flyTo(marker.getLatLng(), 15, { duration: 0.8 });
        this.map.once('moveend', () => marker.openPopup());
      }

      setActive(activeItem) {
        this.items.forEach((item) => item.classList.toggle('is-active', item === activeItem));
      }
    }

    customElements.define('store-locator', StoreLocator);
  })();

  } catch(e) { console.error(e); }
})();
})();
